import React, { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import pq_logo from "../../assets/img/pq_logo_inverted.png";
import { Box } from "@mui/material";

export default function PqLogo(): ReactElement {
  const navigate = useNavigate();

  return (
    (<React.Fragment>
      <Box
        component="img"
        src={pq_logo}
        style={{ marginRight: "36px", cursor: "pointer" }}
        onClick={() => navigate("/uebersicht")}
        alt="TransnetBW Logo"
        sx={{
          width: "200px"
        }}
      />
      {import.meta.env.VITE_ENVIRONMENT !== "prod" && (
        <div
          style={{
            top: "7px",
            position: "absolute",
            left: "7px",
            color: "white",
            backgroundColor: "red",
            transform: "rotate(-30deg)",
            fontSize: "1.2rem",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          {import.meta.env.VITE_ENVIRONMENT}
        </div>
      )}
    </React.Fragment>)
  );
}
